import React, { useEffect } from 'react';

const AdBanner = () => {
  useEffect(() => {
    const scriptConfig = document.createElement('script');
    scriptConfig.type = 'text/javascript';
    scriptConfig.innerHTML = `
      atOptions = {
        'key' : '2a2fc96ef654f5307633075425efe3c7',
        'format' : 'iframe',
        'height' : 300,
        'width' : 160,
        'params' : {}
      };
    `;

    const scriptLoader = document.createElement('script');
    scriptLoader.type = 'text/javascript';
    scriptLoader.src = '//www.highperformanceformat.com/2a2fc96ef654f5307633075425efe3c7/invoke.js';

    const container = document.getElementById('article-top-banner');
    if (container) {
      container.innerHTML = '';
      container.appendChild(scriptConfig);
      container.appendChild(scriptLoader);
    }
  }, []);

  return (
    <div
      id="article-top-banner"
      style={{ width: 160, height: 300, margin: '1.5rem auto' }}
    />
  );
};

export default AdBanner;
